import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import Picker from '@emoji-mart/react'
import emojiData from '@emoji-mart/data'
import { init, SearchIndex } from 'emoji-mart'

// Initialize emoji-mart
init({ data: emojiData }).catch(error => {
  // Swallow error
})

interface IEmoji {
  skins: {
    native: string
    shortcodes?: string
  }[]
  native?: string
  shortcodes?: string
}

interface IEmojiPickerProps {
  /** The currently selected emoji shortcode (e.g., ':palm_tree:') */
  value?: string
  /** Callback when emoji is selected */
  onEmojiSelect: (shortcode: string) => void
  /** Whether the picker is visible */
  visible?: boolean
  /** Callback when visibility changes */
  onVisibilityChange?: (visible: boolean) => void
  /** Custom button text/content */
  buttonContent?: React.ReactNode
  /** Additional CSS class for the button */
  buttonClassName?: string
  /** Whether to show the native emoji in the button */
  showNativeEmoji?: boolean
}

const EmojiPicker: React.FC<IEmojiPickerProps> = ({
  value = ':palm_tree:',
  onEmojiSelect,
  visible = false,
  onVisibilityChange,
  buttonContent,
  buttonClassName = 'ant-input ant-input-emoji',
  showNativeEmoji = true,
}) => {
  const [chosenEmojiNative, setChosenEmojiNative] = useState<string | undefined>()

  // Convert shortcode to native emoji for display
  useEffect(() => {
    const getEmojiNative = async () => {
      if (value) {
        try {
          const emojis: IEmoji[] = await SearchIndex.search(value.replace(/:/g, ''))
          if (emojis.length > 0) {
            const nativeEmojiObject = emojis.find(
              emoji => 
                emoji.shortcodes === value || 
                emoji.skins.some(skin => skin.shortcodes === value)
            )
            const nativeEmoji = nativeEmojiObject?.skins.find(skin => skin.shortcodes === value)?.native || 
                               nativeEmojiObject?.native
            if (nativeEmoji) {
              setChosenEmojiNative(nativeEmoji)
            }
          }
        } catch (error) {
          // Swallow error
        }
      }
    }
    
    if (value) {
      void getEmojiNative()
    }
  }, [value])

  const handleEmojiSelect = (e: { shortcodes: string }) => {
    onEmojiSelect(e.shortcodes)
    onVisibilityChange?.(false)
  }

  const handleButtonClick = () => {
    onVisibilityChange?.(!visible)
  }

  const renderButtonContent = () => {
    if (buttonContent) {
      return buttonContent
    }
    
    if (showNativeEmoji && chosenEmojiNative) {
      return chosenEmojiNative
    }
    
    return value
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Button 
        onClick={handleButtonClick} 
        className={buttonClassName}
      >
        {renderButtonContent()}
      </Button>
      
      {visible && (
        <span className="emoji-picker">
          <Picker
            onEmojiSelect={handleEmojiSelect}
            theme="auto"
            color="#7f00ff"
            emoji=""
            title=""
            sheetSize={32}
            emojiSize={22}
            data={emojiData}
          />
        </span>
      )}
    </div>
  )
}

export default EmojiPicker
